import type { CompetitorRecord } from "@/lib/compare/types";

import { AUTOSHORTS } from "./autoshorts";
import { CAPCUT } from "./capcut";
import { CAPTIONS_AI } from "./captions-ai";
import { CLIPCHAMP } from "./clipchamp";
import { CLIPPIE } from "./clippie";
import { DESCRIPT } from "./descript";
import { EKLIPSE } from "./eklipse";
import { FACELESS_VIDEO } from "./faceless-video";
import { KAPWING } from "./kapwing";
import { KLAP } from "./klap";
import { OPUS_CLIP } from "./opus-clip";
import { QUSO } from "./quso";
import { REVID } from "./revid";
import { RIVERSIDE } from "./riverside-magic-clips";
import { SENDSHORT } from "./sendshort";
import { STORYSHORT } from "./storyshort";
import { STREAMLADDER } from "./streamladder";
import { SUBMAGIC } from "./submagic";
import { SYLLABY } from "./syllaby";
import { VEED } from "./veed";
import { VIZARD } from "./vizard";
import { VSUB } from "./vsub";

export const COMPETITORS: CompetitorRecord[] = [
  OPUS_CLIP,
  CAPCUT,
  SUBMAGIC,
  VIZARD,
  CAPTIONS_AI,
  KLAP,
  EKLIPSE,
  REVID,
  AUTOSHORTS,
  VEED,
  DESCRIPT,
  STREAMLADDER,
  QUSO,
  SENDSHORT,
  STORYSHORT,
  FACELESS_VIDEO,
  SYLLABY,
  RIVERSIDE,
  KAPWING,
  CLIPCHAMP,
  VSUB,
  CLIPPIE,
];

export const COMPETITOR_MAP: Record<string, CompetitorRecord> = Object.fromEntries(
  COMPETITORS.map((record) => [record.slug, record]),
);
